

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _index = require('xo-models/src/onboard/index');

var _directive = require('components/xo-form-components/src/national-id-input/directive');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('../guest/onboardOptions/signup/directive');

require('components/xo-ui-components/src/tooltip/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoGuestUpgradeInterstitial', {
    tag: 'xo-guest-upgrade-interstitial',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        parentModel: {
            type: 'var'
        }
    },

    resolve: {
        experiments: function experiments() {
            return {
                signupComplianceUS: (0, _squid.$pxp)('xo_xoonboarding_signupcompliance_us', { 'ctx.COUNTRY': _squid.$locale.country }, '(xo_xoonboarding_signupcompliance_us_)(.*)')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.flags = this.props.parentModel.flags;
            if (!this.flags) {
                _logger.$logger.info('WPS_interstitial_render_error');
                _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_ALREADY_DONE' });
            }
            this.flags.wpsInterstitial = true;
            this.flags.showMobileEmailSection = true;
            this.onboard = this.props.parentModel.onboard;
        },
        populate: function populate() {
            if (this.experiments.signupComplianceUS && this.experiments.signupComplianceUS.treatment_name === 'xo_xoonboarding_signupcompliance_us_test') {
                this.showNewSignupComplianceExp = true;
            }
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            this.upgrade = new _index.$GuestUpgradeModel();

            this.upgrade.billing_address = this.onboard.billing_address;
            this.upgrade.user = this.onboard.user;
            this.upgrade.payerId = this.onboard.payerId;
            this.upgrade.transaction = this.onboard.transaction;
            this.upgrade.phone = this.onboard.phone;
            this.upgrade.nationalIdModel = _directive.$NationalIdModel.instance(this.props.token);
            this.upgrade.experienceChannel = 'HERMES';

            return this.upgrade.save({

                data: this.upgrade.serialize(),

                success: function success() {
                    _angular.$rootScope.mode = 'signup';
                    _logger.$logger.info('WPS_guest_upgrade_success');
                    return _uiRouter.$state.go('checkout.done');
                },
                error: function error() {
                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_ERROR');
                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                },
                contingencies: {
                    DOB_INVALID: function DOB_INVALID() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_DOB_INVALID');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    },
                    NATID_INVALID: function NATID_INVALID() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_NATID_INVALID');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    },
                    DEFAULT: function DEFAULT() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_Unknown_contingency');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    }
                },
                validation: function validation() {
                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_VALIDATION_ERROR');
                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                }
            });
        }
    }
});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$pxp;

_index.$GuestUpgradeModel;

_directive.$NationalIdModel;

_logger.$logger;

_uiRouter.$state;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js
// module id = ./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js
// module chunks = 1